import 'pages/settings/seo-vars/seo-var-macro-modal.tag'
riot.tag2('seo-vars-macro', '  <catalog object="SeoVariable" cols="{cols}" reload="true" add="{permission(addEdit, &quot;settings&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;settings&quot;, &quot;0001&quot;)}" handlers="{variablesHandlers}" dblclick="{permission(addEdit, &quot;settings&quot;, &quot;1010&quot;)}">\n    <yield to="body">\n      <datatable-cell name="id" style="width: 1%;">{row.id}</datatable-cell>\n      <datatable-cell name="name" style="width: 15%;">{row.name}</datatable-cell>\n      <datatable-cell name="value">\n        <input class="form-control" value="{row.value}" type="text" readonly="true">\n      </datatable-cell>\n      <datatable-cell name="" style="width: 1%;">\n        <button class="btn btn-default" onclick="{handlers.editVars}" title="Редактор"><i class="fa fa-edit"></i></button>\n      </datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.mixin('remove');

self.collection = "SeoVariable";

self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'value', value: 'Значение' }, { name: 'button', value: '' }];

self.variablesHandlers = {
    editVars: function editVars(e) {
        return self.addEdit(e);
    }
};

self.addEdit = function (e) {
    var id;
    if (e.item && e.item.row) {
        id = e.item.row.id;
    }

    modals.create('seo-var-macro-modal', {
        type: 'modal-primary',
        id: id,
        submit: function submit() {
            var _this = this;
            var params = _this.item;

            _this.error = _this.validation.validate(_this.item, _this.rules);

            if (!_this.error) {
                API.request({
                    object: 'SeoVariable',
                    method: 'Save',
                    data: params,
                    success: function success(response) {
                        _this.modalHide();
                        self.tags.catalog.reload();
                    }
                });
            }
        }
    });
};

observable.on('seo-vars-reload', function () {
    self.tags.catalog.reload();
});
});


// WEBPACK FOOTER //
// ./pages/settings/seo-vars/seo-vars-macro.tag